import { useState, useEffect } from "react";
import treesplant from "../../../../assets/trees-plant.png";
import co2emission from "../../../../assets/CO2-emission.png";
import amtraised from "../../../../assets/amount-raised.png";
import CollabarationView from "../CollabarationView";
import ProjectOverviewSummary from "../ProjectOverviewSummary";
import PartnershipsView from "./PartnershipForPdfReport";
import SponsershipView from "../SponsershipView";
import OwnershipView from "./OwnershipForPdfReport";
import SiteDetailsView from "./SiteDetailsForPdfReport";
import ObjectivesView from "./ObectiveForPdfReport";
import RisksView from "../RisksView";
import CostView from "../CostView";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import config from "../../../../utils/config";
import LocationViewReport from "./LocationViewReport";
import { ReactComponent as SelectDropdown } from "../icons/Select_Dropdown.svg";
import project from "../../../../Reducers/Project";
import { Progress, ProgressSize } from "@patternfly/react-core";

export default function ProjectSummaryReport(props) {
  const id = window.location.href.split("/")[4];
  const proId = id.split(":")[1];
  const [projectId, setProjectId] = useState(proId);
  const [projectDetail, setProjectDetail] = useState([]);

  const GetProjectDetailById = (ProjectId) => {
    let UserDetail = {
      ProjectId: ProjectId,
    };
    let uri = `${config.API_HOST_URL}/api/projects/GetProjectDetailById`;
    let fetchOptions = {
      method: "POST",
      body: JSON.stringify(UserDetail),
      headers: {
        WebsiteGuid: props.websiteGUID,
        LanguageGuid: props.languageGUID,
        Authorization: `Bearer ${props.token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    fetch(uri, fetchOptions)
      .then((response) => {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response?.json().then((data) => {
            if (data?.success) {
              setProjectDetail(data?.data);
            } else {
              let errors = {};
              errors["message"] = data?.message;
              setProjectDetail([]);
            }
          });
        } else {
          return response.json().then((data) => {
            let errors = {};
            errors["message"] = data?.message;
          });
        }
      })
      .catch((error) => {
        console.log(error);
        // setErrorMsg(error);
        //setIsLoader(false);
      });
  };

  useEffect(() => {
    setProjectId(proId);
    GetProjectDetailById(proId);
  }, [proId]);

  const [pdfSettings, setPdfSettings] = useState({
    margin: {
      top: 13,
      bottom: 13,
      left: 0,
      right: 0,
    },
    // Other settings as needed
    width: 240,
  });

  const GenereatePdf = () => {
    const element = document.getElementById("content");
    const pdf = new jsPDF();
    html2pdf()
      .from(element)
      .set({
        margin: [
          pdfSettings.margin.top,
          pdfSettings.margin.right,
          pdfSettings.margin.bottom,
          pdfSettings.margin.left,
        ], // Increase the margins (in millimeters)
        width: pdfSettings.width,
        filename: "ProjectReport.pdf",
        image: { type: "png", quality: 1 },
        html2canvas: { scale: 1 },
        pagebreak: {
          mode: ["avoid-all", "css"],
          before: ".page-break-before",
          after: ".page-break-after",
          avoid: ".avoid-this-class",
        }, // Example for page mode
        jsPDF: {
          format: "a3",
          orientation: "portrait",
          unit: "mm",
          compressPDF: true,
          putOnlyUsedFonts: true,
          fontSize: 14,
        },
      })
      .save();
  };

  // Combine content of all child components
  const combinedContent = (
    <>
      <ul className="prosumtop_cont">
        <li>
          <div class="prosum_tree">
            <img src={treesplant} alt="trees plant" />
          </div>
          {projectDetail?.treePlantedTillDate && (
            <div class="prosum_data">
              <span>
                Trees Planted
                <br />
                Till Date
              </span>
              <span>
                {projectDetail?.treePlantedTillDate}{" "}
                {projectDetail?.treeBySourceUsed !== "None"
                  ? projectDetail?.treeBySourceUsed
                  : ""}
              </span>
            </div>
          )}
        </li>
        {/* <li>
          <div class="prosum_tree">
            <img src={co2emission} alt="trees plant" />
          </div>
          {projectDetail?.co2Nutrilized !== undefined && (
            <div class="prosum_data">
              <span>
                Carbon Sequestered - <br /> Till Now
              </span>
              <span>
                {(projectDetail?.co2Nutrilized * 1000).toFixed(2) + " Kg"}
              </span>
            </div>
          )}
        </li> */}
        <li className="prosumtopfunrsed_cont">
          <div class="prosum_tree">
            <img src={amtraised} alt="trees plant" />
          </div>
          <div class="prosum_data">
            <span className="prolisttreedet_lbl">Amount Raised</span>
            <span className="prolisttreedet_val">
              RS. {Math.ceil(projectDetail?.amountRaised / 100000)} L
            </span>
            <span className="totalfndrsedamt_cont">
              ₹ {Math.ceil(projectDetail?.fundraiserGoal / 100000)} L
            </span>
            <div className="prolist_progress">
              <Progress
                value={
                  (projectDetail?.amountRaised /
                    projectDetail?.fundraiserGoal) *
                  100
                }
                size={ProgressSize.sm}
                width="100%"
                fill="#333"
                path="#fff"
              />
            </div>
          </div>
        </li>
      </ul>
      <div className="prosumaccord_cont">
        <div className="prosumrprt_acord">
          <div className="prosumaccord_head">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="26"
              viewBox="0 0 24 26"
              fill="none"
            >
              {" "}
              <path
                d="M22.9826 12.0887C22.8053 12.4546 22.5138 12.5632 22.1136 12.5632C19.9411 12.5517 17.7687 12.5575 15.5962 12.5575C15.0417 12.5575 14.8073 12.3174 14.8015 11.7628C14.7901 11.0367 14.813 10.3164 15.1103 9.64179C15.7791 8.12679 16.9568 7.29782 18.6491 7.09201C17.8944 6.96052 17.2884 6.6518 16.8997 6.02293C16.5109 5.39406 16.4194 4.71945 16.6253 4.01054C16.9797 2.76995 18.1288 2.25542 19.1179 2.34117C20.2498 2.43836 21.1589 3.35308 21.2732 4.43932C21.4047 5.71993 20.5357 6.8862 19.278 7.08057C19.6153 7.17205 20.0269 7.23493 20.3928 7.38929C21.8449 7.99529 22.7024 9.08724 22.9483 10.6423C22.954 10.6823 22.9711 10.7223 22.9883 10.7623C22.9826 11.2025 22.9826 11.6427 22.9826 12.0887Z"
                fill="#D9D9D9"
              />{" "}
              <path
                d="M8.40396 24.2434C8.03235 24.0891 7.90658 23.8089 7.91229 23.4145C7.92373 22.7513 7.91229 22.0881 8.16956 21.4592C8.8213 19.8528 10.0276 18.9895 11.7656 18.7837C11.0681 18.6751 10.4849 18.3949 10.079 17.8289C9.67313 17.2687 9.54164 16.6341 9.67313 15.9595C9.8961 14.7703 10.8966 13.9757 12.0857 14.0214C13.2405 14.0614 14.2353 14.959 14.3668 16.0795C14.5269 17.4173 13.8008 18.3663 12.2801 18.7951C13.4121 18.898 14.3496 19.3554 15.0871 20.1958C15.716 20.9161 16.0476 21.7508 16.0819 22.7055C16.0876 22.9399 16.0705 23.1743 16.0933 23.4087C16.1276 23.8032 15.979 24.0833 15.6074 24.2377C13.2062 24.2434 10.8051 24.2434 8.40396 24.2434Z"
                fill="#D9D9D9"
              />{" "}
              <path
                d="M1.02915 10.8884C1.08061 10.6312 1.12063 10.3739 1.18351 10.1166C1.62944 8.3958 3.04154 7.23525 4.81953 7.12091C7.15779 6.97227 8.99295 8.56731 9.17589 10.8999C9.19876 11.22 9.20448 11.5402 9.19876 11.8603C9.19304 12.2777 8.92434 12.5464 8.51272 12.5464C6.24878 12.5464 3.98485 12.5464 1.72091 12.5521C1.37789 12.5521 1.17208 12.3634 1.02344 12.0833C1.02915 11.6888 1.02915 11.2886 1.02915 10.8884Z"
                fill="#D9D9D9"
              />{" "}
              <path
                d="M5.15111 7.09271C3.84191 7.12129 2.76711 6.09795 2.74425 4.79447C2.71566 3.40524 3.72185 2.35331 5.09394 2.33044C6.38598 2.30757 7.48365 3.36522 7.50651 4.66298C7.52367 5.98933 6.48317 7.06984 5.15111 7.09271Z"
                fill="#D9D9D9"
              />{" "}
              <path
                d="M7.80372 19.4866C7.57504 19.8525 7.35207 20.2069 7.12911 20.5557C5.22535 19.4351 3.52168 16.0049 3.80181 13.8496C4.20772 13.8496 4.61934 13.8496 5.05955 13.8496C5.08242 16.1593 5.99714 18.0459 7.80372 19.4866Z"
                fill="#D9D9D9"
              />{" "}
              <path
                d="M16.8826 20.5559C16.6654 20.2072 16.4424 19.8585 16.208 19.4869C17.0598 18.8237 17.7516 18.0004 18.2375 17.0171C18.7235 16.0281 18.9522 14.9761 18.9465 13.8613C19.3695 13.8613 19.7869 13.8613 20.2042 13.8613C20.6044 15.7537 18.7063 19.5726 16.8826 20.5559Z"
                fill="#D9D9D9"
              />{" "}
              <path
                d="M8.18115 6.73816C10.2107 5.47471 13.7552 5.45184 15.8305 6.73245C15.5218 7.0183 15.2131 7.30987 14.8929 7.59572C14.8586 7.6243 14.7729 7.6243 14.7271 7.60143C13.6752 7.14979 12.5775 7.00115 11.4398 7.08118C10.7138 7.13264 10.0163 7.287 9.34742 7.58428C9.21593 7.64145 9.14161 7.63573 9.03299 7.52711C8.76429 7.2527 8.467 6.99543 8.18115 6.73816Z"
                fill="#D9D9D9"
              />{" "}
            </svg>
            <h3>Collaborations</h3>
          </div>
          <div className="prosumrprt_acordcontent">
            <CollabarationView projectId={projectId} />
          </div>
        </div>
        <div className="prosumrprt_acord">
          <div className="prosumaccord_head">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
            >
              {" "}
              <path
                d="M10.95 20H7.05V16H0L4 10H2L9 0L16 10H14L18 16H10.95V20Z"
                fill="white"
              />{" "}
            </svg>
            <h3>Project Overview</h3>
          </div>
          <div className="prosumrprt_acordcontent">
            <ProjectOverviewSummary
              projectDetail={projectDetail}
              projectId={projectId}
            />
          </div>
        </div>
        {projectId !== "ea23fffa-7e2a-4217-acdd-6515f46b6b05" && (
          <div className="prosumrprt_acord">
            <div className="prosumaccord_head">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="16"
                viewBox="0 0 24 16"
                fill="none"
              >
                <path
                  d="M0 12.8986L2.4 12.9001C3.06563 12.9001 3.6 12.3543 3.6 11.6768V3.13609H0V12.8986ZM1.8 10.4618C2.12813 10.4618 2.4 10.7336 2.4 11.0725C2.4 11.4064 2.12813 11.6832 1.8 11.6832C1.47188 11.6832 1.2 11.4052 1.2 11.0729C1.2 10.733 1.47188 10.4618 1.8 10.4618ZM13.08 0.680182C12.7822 0.680182 12.4928 0.793582 12.273 0.998266L8.58375 4.4347C8.58 4.44234 8.58 4.44997 8.5725 4.44997C7.95 5.04581 7.96125 5.99685 8.49375 6.58886C8.97188 7.08921 9.9705 7.26185 10.5986 6.6939C10.605 6.68817 10.6088 6.68817 10.6125 6.68435L13.608 3.89234C13.8518 3.6681 14.2361 3.68242 14.4563 3.93053C14.6813 4.17864 14.6625 4.56532 14.4188 4.79449L13.4393 5.70619L18.9 10.2173C19.0078 10.3127 19.1063 10.4082 19.1953 10.513V3.09025C17.6586 1.52581 15.5773 0.650391 13.4053 0.650391L13.08 0.680182ZM12.5475 6.53921L11.4225 7.58918C10.3069 8.62463 8.60063 8.52456 7.605 7.42223C6.6 6.3024 6.67875 4.56456 7.77375 3.54095L10.8413 0.680182H10.5938C8.42625 0.680182 6.34125 1.56171 4.8075 3.12081L4.8 11.6725L5.48438 11.674L8.87813 14.799C9.90938 15.6534 11.4188 15.4911 12.2531 14.4459L12.9326 15.028C13.5281 15.4901 14.4094 15.429 14.8969 14.8228L16.0736 13.3485L16.2752 13.5203C16.7908 13.9404 17.5457 13.8641 17.9627 13.339L18.3203 12.889C18.7373 12.3639 18.6592 11.5988 18.1443 11.173L12.5475 6.53921ZM20.4 3.1399V11.6802C20.4 12.3532 20.9344 12.9043 21.5662 12.9043L24 12.9024V3.12845L20.4 3.1399ZM22.2 11.6802C21.8719 11.6802 21.6 11.4034 21.6 11.0695C21.6 10.7305 21.8719 10.4587 22.2 10.4587C22.5281 10.4587 22.8 10.733 22.8 11.0729C22.8 11.4052 22.53 11.6802 22.2 11.6802Z"
                  fill="#D9D9D9"
                />
              </svg>
              <h3>Partnerships</h3>
            </div>
            <div className="avoid-this-class"></div>
            <div className="prosumrprt_acordcontent">
              <PartnershipsView projectId={projectId} />
            </div>
          </div>
        )}
        {projectId !== "ea23fffa-7e2a-4217-acdd-6515f46b6b05" && (
          <div className="prosumrprt_acord">
            <div className="prosumaccord_head">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M15.9991 1.59961H8.00068C7.43508 1.59961 7.04788 2.17161 7.25828 2.69641L7.99988 4.79961H15.9999L16.7415 2.69641C16.9519 2.17161 16.5647 1.59961 15.9991 1.59961Z"
                  fill="#D9D9D9"
                />
                <path
                  d="M15.9999 6.40039H7.9999C7.9999 6.40039 2.3999 11.2004 2.3999 16.8004C2.3999 20.0004 4.7999 21.6004 6.3999 21.6004C7.9999 21.6004 11.9999 21.6004 11.9999 21.6004C11.9999 21.6004 15.9999 21.6004 17.5999 21.6004C19.1999 21.6004 21.5999 20.0004 21.5999 16.8004C21.5999 11.2004 15.9999 6.40039 15.9999 6.40039ZM12.7999 17.5188V18.8004H11.1999V17.5228C10.0231 17.302 9.2831 16.5788 9.2399 15.522H10.6255C10.6919 16.0772 11.2519 16.4332 12.0591 16.4332C12.8039 16.4332 13.3311 16.0724 13.3311 15.5548C13.3311 15.118 12.9895 14.8668 12.1495 14.686L11.2575 14.4964C10.0095 14.2356 9.3967 13.5852 9.3967 12.5412C9.3967 11.4908 10.0919 10.742 11.1999 10.4956V9.20039H12.7999V10.4932C13.8799 10.7348 14.6015 11.4708 14.6367 12.4652H13.2887C13.2223 11.9244 12.7191 11.5636 12.0263 11.5636C11.3095 11.5636 10.8351 11.8956 10.8351 12.418C10.8351 12.8404 11.1623 13.0828 11.9647 13.2532L12.7903 13.4292C14.1671 13.7188 14.7599 14.3124 14.7599 15.3748C14.7599 16.5188 14.0255 17.286 12.7999 17.5188Z"
                  fill="#D9D9D9"
                />
                <path
                  d="M14.4001 3.20078H9.6001C9.6001 1.87518 10.6745 0.800781 12.0001 0.800781C13.3257 0.800781 14.4001 1.87518 14.4001 3.20078Z"
                  fill="#D9D9D9"
                />
              </svg>
              <h3>Sponsorship</h3>
            </div>
            <div className="prosumrprt_acordcontent">
              <SponsershipView projectId={projectId} />
            </div>
          </div>
        )}
        <div className="prosumrprt_acord">
          <div className="prosumaccord_head">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clip-path="url(#clip0_661_1140)">
                <path
                  d="M16 0V6H24L16 0ZM14 6V0H3C1.34312 0 0 1.00734 0 2.25V21.75C0 22.9922 1.34312 24 3 24H21C22.6569 24 24 22.9927 24 21.75V7.5H16.0562C14.8937 7.5 14 6.82969 14 6ZM4 3.375C4 3.17016 4.22687 3 4.5 3H9.5C9.775 3 10 3.17016 10 3.375V4.125C10 4.33031 9.775 4.5 9.5 4.5H4.5C4.22687 4.5 4 4.33031 4 4.125V3.375ZM4 6.375C4 6.16875 4.22687 6 4.5 6H9.5C9.775 6 10 6.16875 10 6.375V7.125C10 7.33125 9.775 7.5 9.5 7.5H4.5C4.22687 7.5 4 7.33125 4 7.125V6.375ZM19 18C19.5547 18 20 18.334 20 18.75C20 19.166 19.5562 19.5 19 19.5H16.0469C15.0231 19.5 14.0938 19.0723 13.6325 18.3806C13.4528 18.1052 13.1325 18.0759 13 18.0759C12.8675 18.0759 12.5469 18.1052 12.375 18.363L11.8906 19.084C11.725 19.3406 11.3188 19.5 11 19.5H10.9312C10.525 19.4766 10.1812 19.2773 10.0562 18.9844L9 16.6219L8.3375 18.1172C7.96875 18.9422 6.9375 19.5 5.77375 19.5H5C4.44562 19.5 4 19.1672 4 18.75C4 18.3328 4.44562 18 5 18H5.77375C6.07844 18 6.34406 17.8535 6.4375 17.6426L7.57812 15.0818C7.78125 14.6203 8.35 14.3109 9 14.3109C9.65 14.3109 10.2188 14.6215 10.4219 15.0844L11.2894 17.0358C12.5238 16.2741 14.6725 16.5787 15.4144 17.6977C15.5394 17.8852 15.7894 18.0023 16.0469 18.0023H19V18Z"
                  fill="#D9D9D9"
                />
              </g>
              <defs>
                <clipPath id="clip0_661_1140">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <h3>Ownership</h3>
          </div>
          <div className="prosumrprt_acordcontent">
            <OwnershipView projectId={projectId} />
          </div>
        </div>
        <div className="prosumrprt_acord">
          <div className="prosumaccord_head">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M18.2862 6.34697C18.2862 2.87481 15.472 0.0605469 11.9993 0.0605469C8.52665 0.0605469 5.71289 2.87481 5.71289 6.34697C5.71289 11.3216 11.9993 18.6824 11.9993 18.6824C11.9993 18.6824 18.2862 11.296 18.2862 6.34697ZM8.89901 5.9716C8.89901 4.25885 10.2876 2.87079 11.9998 2.87079C13.7121 2.87079 15.1006 4.25885 15.1006 5.9716C15.1006 7.68434 13.7121 9.0724 11.9998 9.0724C10.2876 9.0724 8.89901 7.68434 8.89901 5.9716Z"
                fill="#D9D9D9"
              />
              <path
                d="M11.9994 7.49443C12.8414 7.49443 13.524 6.81186 13.524 5.96987C13.524 5.12788 12.8414 4.44531 11.9994 4.44531C11.1574 4.44531 10.4749 5.12788 10.4749 5.96987C10.4749 6.81186 11.1574 7.49443 11.9994 7.49443Z"
                fill="#D9D9D9"
              />
              <path
                d="M15.5537 16.4961C15.0413 17.2363 14.5606 17.8816 14.1601 18.3995C18.1326 18.6379 20.7361 19.4955 21.7046 20.1339C20.57 20.8821 17.1982 21.9339 12.0003 21.9339C6.8023 21.9339 3.43051 20.8816 2.29587 20.1339C3.2644 19.496 5.86589 18.6389 9.83435 18.4C9.43289 17.8821 8.95164 17.2373 8.43877 16.4971C3.55044 16.9784 0 18.4246 0 20.1334C0 22.236 5.37309 23.9412 12.0003 23.9412C18.6279 23.9412 24 22.2365 24 20.1334C24.001 18.4236 20.4465 16.9768 15.5537 16.4961Z"
                fill="#D9D9D9"
              />
            </svg>
            <h3>Location</h3>
          </div>
          <div className="prosumrprt_acordcontent">
            <LocationViewReport projectId={projectId} />
          </div>
        </div>
        {projectId !== "ea23fffa-7e2a-4217-acdd-6515f46b6b05" && (
          <div className="prosumrprt_acord">
            <div className="prosumaccord_head">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clip-path="url(#clip0_878_3175)">
                  <path
                    d="M23.4999 14.9915H20.9999V13.7415C20.9999 13.6752 21.0263 13.6116 21.0732 13.5647C21.1201 13.5178 21.1836 13.4915 21.2499 13.4915H22.9999C23.0875 13.4915 23.1735 13.4685 23.2494 13.4247C23.3253 13.381 23.3883 13.3182 23.4323 13.2424C23.4762 13.1667 23.4995 13.0808 23.4998 12.9932C23.5001 12.9056 23.4774 12.8195 23.4339 12.7435L21.8609 9.9915H22.4999C22.589 9.99139 22.6765 9.96748 22.7533 9.92223C22.83 9.87698 22.8933 9.81204 22.9365 9.73413C22.9797 9.65623 23.0014 9.56818 22.9992 9.47911C22.997 9.39004 22.971 9.30317 22.9239 9.2275L20.4239 5.22751C20.376 5.15962 20.3125 5.10423 20.2387 5.066C20.1649 5.02777 20.083 5.00781 19.9999 5.00781C19.9168 5.00781 19.835 5.02777 19.7612 5.066C19.6874 5.10423 19.6239 5.15962 19.5759 5.22751L17.0759 9.2275C17.0289 9.30317 17.0029 9.39004 17.0007 9.47911C16.9985 9.56818 17.0201 9.65623 17.0634 9.73413C17.1066 9.81204 17.1699 9.87698 17.2466 9.92223C17.3234 9.96748 17.4108 9.99139 17.4999 9.9915H18.1389L16.5649 12.7435C16.5215 12.8196 16.4988 12.9058 16.4991 12.9934C16.4994 13.0811 16.5228 13.1671 16.5669 13.2429C16.6109 13.3186 16.6741 13.3815 16.7502 13.4251C16.8262 13.4688 16.9123 13.4917 16.9999 13.4915H18.7499C18.8162 13.4915 18.8798 13.5178 18.9267 13.5647C18.9736 13.6116 18.9999 13.6752 18.9999 13.7415V15.2245C16.8964 15.7447 14.9388 16.7363 13.2749 18.1245C13.2399 18.1524 13.2131 18.1893 13.1972 18.2311C13.1814 18.273 13.1772 18.3184 13.1849 18.3625C13.1922 18.4068 13.2114 18.4482 13.2405 18.4824C13.2696 18.5166 13.3074 18.5422 13.3499 18.5565C15.5418 19.2364 17.5073 20.4999 19.0359 22.2115C19.2072 22.4185 19.334 22.6584 19.4087 22.9164C19.4833 23.1745 19.5042 23.4451 19.4699 23.7115C19.4653 23.7473 19.4684 23.7838 19.4791 23.8183C19.4898 23.8528 19.5078 23.8846 19.5319 23.9115C19.5553 23.9381 19.5841 23.9593 19.6163 23.9738C19.6486 23.9883 19.6836 23.9957 19.7189 23.9955H23.4999C23.6326 23.9955 23.7597 23.9428 23.8535 23.8491C23.9473 23.7553 23.9999 23.6281 23.9999 23.4955V15.4955C24.0005 15.4295 23.9879 15.3641 23.963 15.3029C23.9381 15.2418 23.9014 15.1862 23.8549 15.1394C23.8084 15.0925 23.7531 15.0553 23.6922 15.0299C23.6313 15.0046 23.5659 14.9915 23.4999 14.9915Z"
                    fill="#D9D9D9"
                  ></path>
                  <path
                    d="M0.222 21.0769C0.153635 21.1226 0.0976067 21.1845 0.0588823 21.2571C0.0201578 21.3296 -6.70719e-05 21.4106 1.67108e-07 21.4929V23.4929C1.67108e-07 23.6255 0.0526786 23.7527 0.146447 23.8464C0.240215 23.9402 0.367392 23.9929 0.5 23.9929H17.5C17.595 23.9929 17.688 23.9658 17.7682 23.9148C17.8484 23.8638 17.9123 23.791 17.9526 23.7049C17.9929 23.6189 18.0079 23.5232 17.9957 23.4289C17.9836 23.3347 17.9448 23.2459 17.884 23.1729C15.437 20.2359 10.906 19.2179 8 19.0289V16.7429C8 16.6766 8.02634 16.613 8.07322 16.5661C8.12011 16.5192 8.1837 16.4929 8.25 16.4929H11.54C11.7229 16.4927 11.9023 16.4424 12.0586 16.3474C12.2149 16.2524 12.3421 16.1163 12.4265 15.954C12.5108 15.7917 12.549 15.6094 12.537 15.4269C12.5249 15.2444 12.463 15.0687 12.358 14.9189L9.958 11.4929H10.587C10.7662 11.4928 10.942 11.4446 11.0961 11.3532C11.2503 11.2619 11.377 11.1309 11.4632 10.9738C11.5494 10.8167 11.5917 10.6394 11.5859 10.4603C11.58 10.2812 11.5262 10.107 11.43 9.9559L8.885 5.9559C9.03288 5.91425 9.16916 5.83908 9.28329 5.73624C9.39742 5.6334 9.48632 5.50565 9.5431 5.3629C9.59987 5.22014 9.62299 5.06623 9.61066 4.91309C9.59833 4.75996 9.55088 4.61173 9.472 4.4799L6.929 0.235897C6.88125 0.166185 6.81722 0.109161 6.74248 0.0697592C6.66773 0.0303575 6.5845 0.00976563 6.5 0.00976562C6.4155 0.00976563 6.33227 0.0303575 6.25752 0.0697592C6.18278 0.109161 6.11875 0.166185 6.071 0.235897L3.525 4.4789C3.44593 4.61083 3.39836 4.75922 3.38599 4.91253C3.37362 5.06584 3.39678 5.21994 3.45367 5.36284C3.51056 5.50574 3.59964 5.63359 3.714 5.73645C3.82835 5.83931 3.96489 5.91441 4.113 5.9559L1.568 9.9559C1.47153 10.107 1.41748 10.2814 1.4115 10.4606C1.40552 10.6398 1.44785 10.8173 1.53403 10.9745C1.62022 11.1318 1.7471 11.263 1.90138 11.3543C2.05567 11.4457 2.23169 11.4939 2.411 11.4939H3.04L0.64 14.9199C0.53496 15.0697 0.473052 15.2455 0.46102 15.4281C0.448987 15.6107 0.487291 15.7931 0.571759 15.9555C0.656227 16.1178 0.783621 16.2539 0.940064 16.3488C1.09651 16.4437 1.276 16.4939 1.459 16.4939H4.75C4.8163 16.4939 4.87989 16.5202 4.92678 16.5671C4.97366 16.614 5 16.6776 5 16.7439V19.1539C3.2839 19.4307 1.65141 20.0878 0.222 21.0769Z"
                    fill="#D9D9D9"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_878_3175">
                    <rect width="24" height="24" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
              <h3>Site Details</h3>
            </div>
            <div className="prosumrprt_acordcontent">
              <SiteDetailsView projectId={projectId} />
            </div>
          </div>
        )}
        <div className="prosumrprt_acord">
          <div className="prosumaccord_head">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <g clip-path="url(#clip0_878_3171)">
                <path
                  d="M23.6578 4.26914L20.7138 3.28714L19.7318 0.342136C19.7043 0.259499 19.6557 0.185478 19.5908 0.127402C19.5259 0.0693258 19.4469 0.0292086 19.3617 0.0110226C19.2766 -0.00716344 19.1881 -0.00278739 19.1052 0.0237174C19.0222 0.0502223 18.9476 0.0979365 18.8888 0.162136L16.1308 3.16214C16.0464 3.25445 15.9996 3.37505 15.9998 3.50014V6.94014L14.7998 8.13414C13.0863 6.69055 10.8956 5.93866 8.65673 6.02573C6.41789 6.1128 4.2922 7.03255 2.696 8.60485C1.0998 10.1772 0.148086 12.2887 0.0272551 14.526C-0.0935753 16.7633 0.625185 18.9651 2.04276 20.7001L0.714762 22.3801C0.554293 22.5885 0.482395 22.8518 0.514643 23.1128C0.546891 23.3739 0.680688 23.6117 0.88705 23.7748C1.09341 23.9379 1.35572 24.0131 1.61715 23.9841C1.87858 23.9552 2.11808 23.8244 2.28376 23.6201L3.48376 22.0991C5.09336 23.357 7.08427 24.0274 9.12687 23.9994C11.1695 23.9714 13.1413 23.2466 14.7158 21.9451L16.2498 23.6651C16.4281 23.8601 16.6755 23.9777 16.9393 23.9928C17.2031 24.008 17.4623 23.9194 17.6618 23.7461C17.8596 23.5698 17.9794 23.3222 17.9947 23.0576C18.0101 22.793 17.9198 22.5332 17.7438 22.3351L16.1098 20.5001C17.2371 19.0525 17.8926 17.2936 17.9878 15.4613C18.0829 13.629 17.6131 11.8117 16.6418 10.2551C16.621 10.2225 16.5931 10.1951 16.5602 10.1747C16.5274 10.1544 16.4903 10.1417 16.4519 10.1377C16.4134 10.1337 16.3746 10.1383 16.3382 10.1514C16.3018 10.1645 16.2689 10.1856 16.2418 10.2131L14.5998 11.8591C14.5631 11.8956 14.5391 11.9429 14.5313 11.994C14.5236 12.0452 14.5325 12.0975 14.5568 12.1431C15.2685 13.5197 15.4463 15.1109 15.0558 16.6106C14.6653 18.1103 13.7342 19.4127 12.4415 20.2674C11.1487 21.1221 9.58567 21.4687 8.05284 21.2405C6.52 21.0124 5.12562 20.2257 4.1378 19.0316C3.14999 17.8375 2.6385 16.3203 2.70167 14.7719C2.76484 13.2235 3.39823 11.7531 4.48003 10.6434C5.56183 9.53377 7.01567 8.86322 8.562 8.76072C10.1083 8.65821 11.638 9.13099 12.8568 10.0881L11.7818 11.1631C11.2391 10.7635 10.6169 10.4852 9.9573 10.3472C9.29768 10.2092 8.6161 10.2146 7.95876 10.3631C7.13358 10.5495 6.37312 10.9528 5.75594 11.5313C5.13877 12.1099 4.68726 12.8427 4.44808 13.6542C4.2089 14.4656 4.19072 15.3262 4.39541 16.147C4.60011 16.9679 5.02025 17.7191 5.61244 18.3233C6.20463 18.9274 6.94738 19.3624 7.76395 19.5834C8.58053 19.8045 9.44131 19.8034 10.2574 19.5805C11.0734 19.3575 11.8151 18.9207 12.4059 18.3152C12.9966 17.7097 13.415 16.9574 13.6178 16.1361C13.8366 15.2525 13.7946 14.3244 13.4968 13.4641C13.4816 13.4248 13.4568 13.3898 13.4247 13.3626C13.3925 13.3353 13.354 13.3165 13.3127 13.3079C13.2714 13.2994 13.2286 13.3013 13.1883 13.3136C13.1479 13.3258 13.1113 13.348 13.0818 13.3781L10.9218 15.5371C10.8101 15.9253 10.583 16.2702 10.2706 16.5262C9.95825 16.7822 9.57537 16.9371 9.17287 16.9703C8.77037 17.0034 8.3673 16.9134 8.0172 16.712C7.66711 16.5107 7.38656 16.2076 7.21284 15.843C7.03911 15.4784 6.98043 15.0696 7.04459 14.6708C7.10875 14.2721 7.29272 13.9023 7.57204 13.6106C7.85137 13.3189 8.21284 13.1191 8.60843 13.0378C9.00401 12.9564 9.41499 12.9974 9.78676 13.1551L8.59976 14.3401C8.53007 14.4098 8.47478 14.4925 8.43706 14.5835C8.39934 14.6745 8.37992 14.7721 8.37992 14.8706C8.37992 14.9692 8.39934 15.0667 8.43706 15.1578C8.47478 15.2488 8.53007 15.3315 8.59976 15.4011C8.74218 15.5386 8.93236 15.6153 9.13026 15.6153C9.32817 15.6153 9.51835 15.5386 9.66076 15.4011L17.0598 8.00014H20.4998C20.6253 8.00026 20.7463 7.95314 20.8388 7.86814L23.8388 5.11214C23.9029 5.05327 23.9506 4.97867 23.9771 4.8957C24.0036 4.81274 24.008 4.7243 23.9898 4.63914C23.9715 4.55387 23.9312 4.47486 23.873 4.40995C23.8148 4.34505 23.7406 4.2965 23.6578 4.26914Z"
                  fill="#D9D9D9"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_878_3171">
                  <rect width="24" height="24" fill="white"></rect>
                </clipPath>
              </defs>
            </svg>
            <h3>Objective </h3>
          </div>
          <div className="prosumrprt_acordcontent">
            <ObjectivesView projectId={projectId} />
          </div>
        </div>
        {projectId !== "ea23fffa-7e2a-4217-acdd-6515f46b6b05" && (
          <div className="prosumrprt_acord">
            <div className="prosumaccord_head">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M21.05 18.7069L13.0611 3.87094C12.4948 2.81906 10.9864 2.81906 10.4197 3.87094L2.43122 18.7069C2.30827 18.9352 2.24663 19.1916 2.25231 19.4508C2.258 19.7101 2.33081 19.9635 2.46365 20.1863C2.59648 20.409 2.7848 20.5935 3.01022 20.7217C3.23564 20.85 3.49046 20.9176 3.74981 20.918H19.729C19.9886 20.918 20.2437 20.8507 20.4694 20.7226C20.6952 20.5945 20.8838 20.4101 21.0169 20.1873C21.1501 19.9644 21.2231 19.7109 21.2289 19.4514C21.2346 19.1919 21.173 18.9354 21.05 18.7069ZM11.7406 18.6211C11.5552 18.6211 11.3739 18.5661 11.2197 18.4631C11.0656 18.3601 10.9454 18.2137 10.8745 18.0424C10.8035 17.8711 10.7849 17.6826 10.8211 17.5007C10.8573 17.3188 10.9466 17.1518 11.0777 17.0207C11.2088 16.8896 11.3758 16.8003 11.5577 16.7641C11.7396 16.7279 11.9281 16.7465 12.0994 16.8175C12.2707 16.8884 12.4171 17.0086 12.5201 17.1627C12.6231 17.3169 12.6781 17.4982 12.6781 17.6836C12.6781 17.8067 12.6538 17.9286 12.6067 18.0424C12.5596 18.1561 12.4906 18.2595 12.4035 18.3465C12.3165 18.4336 12.2131 18.5026 12.0994 18.5497C11.9856 18.5968 11.8637 18.6211 11.7406 18.6211ZM12.7587 9.19219L12.4897 14.9109C12.4897 15.1098 12.4106 15.3006 12.27 15.4413C12.1293 15.5819 11.9386 15.6609 11.7397 15.6609C11.5407 15.6609 11.35 15.5819 11.2093 15.4413C11.0687 15.3006 10.9897 15.1098 10.9897 14.9109L10.7206 9.19453C10.7145 9.05793 10.7361 8.92151 10.7839 8.79341C10.8317 8.6653 10.9048 8.54813 10.9988 8.44888C11.0929 8.34963 11.2059 8.27033 11.3313 8.2157C11.4566 8.16108 11.5917 8.13225 11.7284 8.13094H11.7382C11.8759 8.13087 12.0122 8.15869 12.1388 8.21272C12.2654 8.26675 12.3797 8.34587 12.4749 8.44531C12.5701 8.54475 12.6442 8.66245 12.6926 8.7913C12.7411 8.92015 12.7629 9.05748 12.7568 9.195L12.7587 9.19219Z"
                  fill="#D9D9D9"
                ></path>
              </svg>
              <h3>Risk </h3>
            </div>
            <div className="prosumrprt_acordcontent">
              <RisksView projectId={projectId} />
            </div>
          </div>
        )}
        {projectId !== "ea23fffa-7e2a-4217-acdd-6515f46b6b05" && (
          <div className="prosumrprt_acord">
            <div className="prosumaccord_head">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="21"
                viewBox="0 0 24 21"
                fill="none"
              >
                <g clip-path="url(#clip0_878_3163)">
                  <path
                    d="M23.3206 11.812L13.4373 11.812L19.9831 18.2924C20.2383 18.5436 20.6494 18.5584 20.9098 18.3226C22.519 16.8255 23.6285 14.8108 23.9565 12.5435C24.0498 12.1565 23.7248 11.812 23.3206 11.812ZM22.629 9.15419C22.2852 4.25282 18.3081 0.372741 13.329 -0.000501432C12.9488 -0.0261321 12.6306 0.291243 12.6306 0.665592L12.6665 9.84325L21.9873 9.8432C22.3706 9.84325 22.6915 9.53153 22.629 9.15419ZM10.6665 11.812V2.08104C10.6665 1.68631 10.3177 1.36409 9.92188 1.42028C4.95813 2.11262 1.16188 6.38153 1.33896 11.5003C1.52125 16.7544 6.12229 21.0651 11.4598 20.9995C13.5585 20.9739 15.5015 20.3072 17.0931 19.1948C17.4264 18.9641 17.4468 18.4877 17.1603 18.2059L10.6665 11.812Z"
                    fill="#D9D9D9"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_878_3163">
                    <rect width="24" height="21" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
              <h3>Cost </h3>
            </div>
            <div className="prosumrprt_acordcontent">
              <CostView projectId={projectId} />
            </div>
          </div>
        )}
      </div>
    </>
  );

  useEffect(() => {
    if (projectId && projectDetail?.treePlantedTillDate) {
      setTimeout(() => {
        GenereatePdf();
      }, 5000);
    }
  }, [projectId, projectDetail]);

  return (
    <>
      <div className="prosumryrprt_btncont">
        {/* <button onClick={GenereatePdf}>
          Download Report
          <SelectDropdown />
        </button> */}
      </div>
      <div className="prosumreport_cont" id="content">
        <div className="Pojectsummary_cont">{combinedContent}</div>
      </div>
    </>
  );
}
